module.exports = {
    userauth: '用户权限',
    mediasource: '媒体资源',
    publicsource: '公共资源',
    publicresources: '资源',
    whatsnewsetting: ' 新闻活动',
    exhibitionWall: '照片墙',
    account: '账户信息',
    helpcenter: '帮助中心',
    feedback: '反馈',
    companyName: '公司名称',
    SubscriptionSetting:'Subscription Setting',
    activeServicesModule: '当前服务模块',
    nickName: '昵称',
    enterNickNameTip: '请输入昵称',
    serviceTeam: '服务团队',
    apiDocuments: 'API 文档',
    SubscriptionSetting:'订阅设置',
    qualityManagement: '质量管理',
    productUpdates: '产品更新',
    day:'日期',
    email_acount:'邮箱(客户账号)',
    mustwrite:'不能为空',
    operatingManuals: '操作手册',
    profit_rate:'利润率',
    createNew:'开通新的网盟ADV',
    profit:'利润',
    affiliate_cost:'AFF花费',
    en_Case:'英文文档',
    event_cost:'事件花费',
    a_cost:'事件花费',
    pskul:'请填写网红链接',
    api: 'API 文档',
    quality: '质量管理',
    product: '产品更新',
    operating: '操作手册',
    influencer_name:'网红',
    all: 'All',
    fast: 'Fast',
    faq: 'Faq',
    read: '已读',
    userSetting:'用户设置',
    TimeDates:'时间',
    open:'打开',
    Campaign:'广告系列',
    ROAS:'回报率',
    close:'置灰',
    changeTabletips:'修改表格失败',
    unread: '未读',
    accountAuthority:'账户权限',
    tips:'这个广告主已经选过了。请重新选择！',
    empty:'广告主和模块不能为空',
    Advertiser:'广告主',
    fusionAdvertiser:'融合广告主',
    logo:'图标',
    BusinessType:'业务类型',
    Operation:'操作',
    Role:'角色',
    username:'用户名称',
    Publicsetting:'公共设置',

    Report:'报告',
    Reports_en:'英文报告',
    ReleaseDate:'发行时间',
    Type:'类型',
    Launch:'发布',

    Modules:'模块',
    Module:'模块',
    ProfilePhoto:'头像',
    Email:'邮箱',
    Name:'姓名',
    Account:'姓名',
    Position:'职位',

    Title:'主题',
    Title_en:'英文主题',
    Abstract:'摘要',
    Operatedate:'操作日期',
    Uploadtime:'文件上传时间',
    Case:'文件',
    Format:'文件格式',

    No:'序号',
    Account:'账户号',
    OriginalAffID:'原始渠道编号',
    Status:'状态',
    AffID:'渠道编号',
    Percent:'百分比',
    AffName:'渠道名称',

    ARPU: "ARPU",
    Login: "Login",
    Login_Rate: "Login Rate",
    Pay: 'Pay',
    Pay_Rate: 'Pay Rate',
    Purchase: "Purchase",
    Retention: "Retention",
    rentention:'留存',
    roi:'投资回报率',
    Retention_Rate: "Retention Rate",
    adv_id: "广告主",
    app_name: "应用产品名称",
    click:'点击',
    clicks:'点击',
    Click:'点击',
    conversion: '转化',
    Conversion:'转化',
    i_a_cost: "花费",
    cost:'花费',
    country: "国家",
    cr: '点击转化率',
    ctr: '点击率',
    impression: '展示',
    impressions: '展示',
    ivr: '展示转化率',
    media_source: "媒体资源",
    revenue: "收入",
    Revenue:'收入',
    time_zone: "时区",

    total:'总计',
    date:'日期',
    advertiser:'广告主',
    campaign: "产品",
    campaignId_new:'推广活动名称',
    cpm: "千次付费",
    influencer: "网红",
    launch_time: "发布时间",
    platform: "平台",
    view_count: "浏览量",
    view_count2:"浏览量(点赞量)",
    Percentage:'占比',
    Click:'点击',
    Order:'订单',
    Cost:'花费',

    Instructionsforuse:'使用说明',
    AboutYeahagency:'关于Yeahgrowth',
    QuickStart:'一望而知',
    ProductUpdates:'产品更新',
    QualityManagement:'质量管理',
    APIDocuments:"API文档",

    download:'下载',
    Downloads:'下载量',
    Pkg_name:'包名',
    DAU:'日活跃用户数量(昨天)',
    Results:'结果',
    Rdtools:'R&d工具',
    currency:'币种',
    shadow_aff_id: '媒体资源ID',
    shadow_aff_name: '媒体资源',
    local_cost: '花费(当地货币)',
    usacost: '花费(美元)',
    mediaNull:'媒体资源不能为空',
    Event:'事件',
    events:'事件',
    priceNull:'价格不能为空',
    seemore:'查看更多',
    pkgchanged:'pkg拉取状态已更改',
    order:'订单',
    All:'全部',
    Active:'激活',
    Close:'关闭',
    advName:'广告主名称',
    Install:'安装',
    Retargeting: '再营销',
    Clicks:'点击',
    cvr:'CVR',
    CVR:'CR',
    a_count:'事件',
    imp:'IMP',
    sinEvent:"此产品在事件设置中已经使用",
    sinSet:"此产品在安装设置中已经使用",
    norepeat: '包名不能重复,请重新填写',
    es:'事件设置',
    is:'安装设置',
    retargetingSetting: '再营销设置',
    Timerange:'时间范围',
    installs:'安装',
    Product:'产品',
    Creative:'文件',
    Format:'格式',
    Createtime:'创建时间',
    cost$:'花费 (美元)',
    Date:'日期',
    Select:'请选择',
    influencerName:'网红名',
    influencerlink:'网红发布链接',
    camName:'产品名',
    camLink:'产品链接',
    psa:'请选择广告主',
    psp:'请选择平台',
    pic:'请填写产品',
    pii:'请填写网红',
    password:'密码',
    bussinessType:'模块类型',
    pst:'请选择类型',
    pia:'请输入账户号',
    btir:'请选择模块类型',
    scn:'查询文件名',
    accounType:'账户类型',
    global:'全局权限',
    pkg:'部分权限',
    activities:'活动',
    awards:'获奖',
    psyp:'请选择职位',
    psyn:'请选择账户',
    psye: '请填写姓名',
    psym:'请选择模块',
    Upload:'上传',
    Upload_file:'上传报告',
    pece:'请填写正确格式的邮箱',
    ps:'请选择',
    Upload_cover:'上传图片',
    About:'关于Yeahgrowth',
    Quick:'一望而知',
    Instruction:'使用说明',
    moduleSetting:'模块设置',

    AdvId:'广告主',
    appName:'应用产品名称',
    timezone:'时区',
    MediaSource:'媒体资源',
    Country:'国家',
    rosa:'回报率',
    roas:'回报率',
    Report_en:'英文报告',
    eng:'英语',
    ch:'中文',
    En:'英',
    Cn:'中',
    systemManagement: '系统管理',
    clientInformation: '客户信息',
    clientAccountSetting: '客户账号设置',
    teamServiceSetting: '服务团队设置',
    businessAuthoritySetting: '业务权限设置',
    teamMembers: '团队成员',
    noupload:'暂未上传照片',
    menuAuth: '菜单权限',
    apiAuth: '接口权限',


    BisicSetting:'基础设置',
    customerProduct:'客户产品',
    CustomerAccount:'客户账号',
    company:'公司名称',
    status:'状态',
    phone:'联系信息',
    createDate:'创建日期',
    updateDate:'更新日期',
    hangye:'行业',
    address:'注册地址',
    website:'公司网址',
    customer:'客户',
    productType:'产品类型',
    productName:'产品名称',
    productPic:'产品图片',
    packageName:'产品PKG',
    appName:'App名称',
    platformFE:'平台支持',
    applogos:'App图标',
    firstName:'姓',
    lastName:'名',
    email:'邮箱',
    Openservice:'开通业务',
    productlimits:'产品权限',
    accountType:'账户类型',
    orderId:'合同编号',

    associatedAccount:'广告主ID',
    pi:'请输入',
    name:'姓名',
    pro:'产品',
    accou:'账户',
    pczs:'请选择开通业务',
    menuAuth: 'Menu Auth',
    apiAuth: 'Api Auth',
    selectfeew:'请选择客户',
    isof:'归属于：',
    dateEmpty:'暂无内容',
    docedit:'文档设置',
    delete_item:'确定删除该节点吗？',
    sure:'确定',
    cancel:'取消',
    folder:'章节',
    file:'文档',
    tagsetting:'标签设置',
    authorityseting:'分享',
    submit:'提交',
    save:'保存',
    pwct:'请填写中文标题',
    pwet:'请填写英文标题',
    createman:'创建人',
    tipssave:'温馨提示',
    needsave:'文件内容有修改,需要保存吗？',
    Signing : '签约账号',
    Sub : '子账号',
    Main :'客户主账号',
    re_engagement: '再互动',
    re_attribution: '再归因',
    re_setting_pwd:'重置密码',
    checktip:'点击检查将自动填充下方的信息',
    Check:'检查',
    productPicin:'请上传图片',
    errorpkg:'从应用商店获取信息失败，请检查应用名称',
    delbasic:'删除该记录，会同时删除相关产品和客户账号，请确认再删除',
    
}



// WEBPACK FOOTER //
// ./src/i18n/modules/authority/zh-cn.js